<div [formGroup]="fg">
    <div class="action-setting">
        <div class="action-setting-title">
            {{ "commonActions.waitAction.waitTime" | labelsProvider }}
        </div>
        <div class="await-container">
            <input class="input amount-input" type="number" formControlName="waitAmount" appOnlyNumbers min="0" />
            <app-select-v2
                class="row-title wait-units"
                [placeHolder]="'common.select' | labelsProvider"
                [options$]="timeUnitOptions$"
                [canBeEmpty]="false"
                (optionOnSelection)="waitUnitTypeOnSelection($event)"
                [selectedId]="fg.controls['waitUnitType'].value">
            </app-select-v2>
        </div>
        <div class="actions-invalid" *ngIf="fg.invalid">* Wait time must be between 3-30 days.</div>
    </div>
</div>
